/**
 * Returns the singular or plural English form of a word based on the count.
 *
 * If plural form is not provided, most common English form is produced by appending "s".
 */
export const plural = (count: number, singular: string, plural?: string) =>
  count === 1 ? singular : (plural ?? `${singular}s`);
